(function() {
  // Obtén todos los elementos .slider-item
  var reviewSliderItem = document.querySelectorAll('.review-item');
  if (reviewSliderItem.length > 1) {
    // Inicializa el slider
    var slideReviews = tns({
      container: '.reviews-slider',
      items: 1,
      slideBy: 'page',
      autoplay: false,
      mouseDrag: true,
      speed: 500
    });
    
  
    // Obtén el total de slides
    var totalSlides = slideReviews.getInfo().slideCount;
    // Actualiza la información de navegación inicialmente
    var initialInfo = slideReviews.getInfo();
    var initialSlide = initialInfo.displayIndex;
  
    // Crea un elemento para mostrar la información de navegación
    var navInfo = document.createElement('p');
    var sliderContainer = document.querySelector('.reviews-slider-container .tns-outer .tns-ovh .tns-inner');
    sliderContainer.appendChild(navInfo);
    navInfo.classList.add('nav_sauna');
  
    navInfo.textContent = initialSlide + ' • ' + totalSlides;
  
    // Obtén el botón de "next"
    var nextButton = document.querySelector('.tns-controls [data-controls="next"]');
  
      // Crea un elemento SVG
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '11');
    svg.setAttribute('height', '16');
    svg.setAttribute('viewBox', '0 0 11 16');
    svg.setAttribute('fill', 'none');
  
    // Crea un elemento de ruta para el SVG
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M0 16L7.89753 8L0 0L3.1086 0L11 8L3.1086 16H0Z');
    path.setAttribute('fill', '#F3F2EF');
  
    // Agrega el elemento de ruta al SVG
    svg.appendChild(path);
  
    // Reemplaza el contenido del botón de "next" con el SVG
    nextButton.innerHTML = '';
    nextButton.appendChild(svg);
  
    // Mueve el botón de "next" al contenedor deseado
    sliderContainer.appendChild(nextButton);
  
    // Agrega un controlador de eventos para el botón de "next"
    nextButton.addEventListener('click', function() {
      slideReviews.goTo('next');
    });
  
    // Actualiza la información de navegación cada vez que se cambia el slide
    slideReviews.events.on('indexChanged', function(info) {
        var currentSlide = info.displayIndex;
        navInfo.textContent = currentSlide + ' • ' + totalSlides;
    });
  
  }
  
  //prev
  
    // Obtén el botón de "prev"
    var prevButton = document.querySelector('.tns-controls [data-controls="prev"]');
  
    // Crea un elemento SVG para el botón de "prev"
    var svgPrev = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svgPrev.setAttribute('width', '11');
    svgPrev.setAttribute('height', '16');
    svgPrev.setAttribute('viewBox', '0 0 11 16');
    svgPrev.setAttribute('fill', 'none');
  
    // Crea un elemento de ruta para el SVG
    var pathPrev = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    pathPrev.setAttribute('d', 'M11 0L3.10247 8L11 16L7.8914 16L0 8L7.8914 0H11Z'); // Nota: esta es la ruta del SVG volteada
    pathPrev.setAttribute('fill', '#F3F2EF');
  
    // Agrega el elemento de ruta al SVG
    svgPrev.appendChild(pathPrev);
  
    // Reemplaza el contenido del botón de "prev" con el SVG
    prevButton.innerHTML = '';
    prevButton.appendChild(svgPrev);
  
    // Mueve el botón de "prev" al contenedor deseado
    sliderContainer.appendChild(prevButton);
  
    // Agrega un controlador de eventos para el botón de "prev"
    prevButton.addEventListener('click', function() {
      slideReviews.goTo('prev');
    });
  
  
  
  })();